import { ReactComponent as CloseIcon } from 'icons/icon-close-large.svg';
import { ReactComponent as CaretLeft } from 'icons/icon-caret-left.svg';
import { Toolbar, CloseButton, BackLink } from './Glossary.style';
import { string, bool, func, oneOf } from 'prop-types';

/** GlossaryToolbar displays a simple 'back to Glossary' link at the top of GlossaryTerm components. */
const GlossaryToolbar = ({
  hide,
  modal,
  showClose,
  borderPosition,
  openFromSide,
}) => {
  return (
    <Toolbar borderPosition={borderPosition} openFromSide={openFromSide}>
      {openFromSide === undefined && (
        <BackLink
          to={{
            pathname: '/glossary',
            state: {
              modal,
            },
          }}
        >
          <CaretLeft /> <span className="backlink-label">Glossary</span>
        </BackLink>
      )}
      {showClose && (
        <CloseButton onClick={hide} data-pw="ModalCloseButton">
          <CloseIcon />
        </CloseButton>
      )}
    </Toolbar>
  );
};

GlossaryToolbar.propTypes = {
  /** The action to perform when you want to close the modal. Only required when modal is set to true */
  hide: func,
  /** Indicates if you are in a modal view */
  modal: bool.isRequired,
  /** Indicates if you want to show the close icon */
  showClose: bool,
  /** Indicates where the border of the toolbar should be displayed */
  borderPosition: oneOf(['top', 'bottom']),
  /** Indicates where the border of the toolbar should be displayed */
  openFromSide: string,
};

GlossaryToolbar.defaultProps = {
  showClose: false,
};

export default GlossaryToolbar;
